import { Helmet } from "react-helmet";

import { ProtectedApp } from "common/app/protected-app.component";
import { Login } from "features/login-screen/login.container";
import { useAuth } from "common/context/auth/auth-context";

function App() {
  const { user } = useAuth();

  return (
    <>
      <Helmet titleTemplate="BudgetFYI - %s" />
      {user === null ? <Login /> : <ProtectedApp />}
    </>
  );
}

export default App;
